<ng-container *ngIf="model$ | async as model">
  <div class="mb-header-width"
       *ngIf="!isCategoryPage"
  >
    <span class="mb-search-tab-button"
          data-cy="mb-product-result-button"
          [class.is-active]="!showContentTab"
          (click)="showContent(false)"
    >
      {{ 'searchResultItem.products' | mbTranslate }}
      <span class="mb-results-count"> ({{model.pagination?.totalResults}})</span>
    </span>
    <span class="mb-search-tab-button mb-search-content-button"
          data-cy="cms-content-result-button"
          [class.is-active]="showContentTab"
          (click)="showContent(true)"
    >
      {{ 'searchResultItem.content' | mbTranslate }}
      <span *ngIf="cmsModel$ | async as cmsModel"
            class="cms-results-count"
            data-cy="cms-results-count"
      >({{cmsModel?.numberOfResults || 0}})</span>
    </span>
  </div>
  <div [style.display]="showContentTab ? 'none' : 'block'"
       data-cy="mb-search-result-list-item"
  >
    <mb-active-facets [activeFacets]="activeFacetsList"
                      [readOnlyFacets]="readOnlyFacets"
    >
    </mb-active-facets>
    <mb-search-results-scroll [model]="model"
                              [scrollConfig]="scrollConfig"
                              [inputViewMode]="viewMode"
    >
    </mb-search-results-scroll>
  </div>
  <div [style.display]="showContentTab ? 'block' : 'none'"
       data-cy="mb-search-content-item"
  >
    <mb-cms-active-facets></mb-cms-active-facets>
    <mb-cms-search-results [isSearchPage]="true"
                           [globalSearch]="true"
    ></mb-cms-search-results>
  </div>
</ng-container>

